module.exports = __webpack_public_path__ + "static/iso_7.60a4dc84.jpg";